import React, { useState } from 'react';
import { classIf } from '../data/utils/classIf';
import { filterBetsByNumberOfOdds } from '../data/utils/filterBetsByNumberOfOdds';
import { filtraParametriche } from '../data/utils/filtraParametriche';
import { getConfiguration } from '../data/utils/configuration';
import { iconSportCssClass } from '../data/utils/iconSportCssClass';
import { parseIntFromString } from '../data/utils/parseIntFromString';
import { useFetch } from '../data/fetch/useFetch';
import { parseWidgetData } from '../data/parseWidgetData';
import Loader from '../common/Loader';
import TournamentEvent from '../prematch/TournamentEvent';
import { useParams } from 'react-router-dom';
import { systemCode, urls } from '..';
import XRouterLink from '../common/seo/xrouter/XRouterLink';
import { getLabel } from '../data/labels';

function UpcomingContent(props) {
    const [selectedSport, setSelectedSport] = useState(props.sports[0]);

    const sportButtons = props.sports.map(sport => {
        const selected = sport === selectedSport;
        return (
            <div key={sport} className={"l_2_1" + classIf(selected, 'selected')} onClick={() => setSelectedSport(sport)}>
                <div className={`l_2_1_1 ${iconSportCssClass(sport, null)}`}></div>
                <span className="l_2_1_2">{props.descBySport[sport]}</span>
            </div>
        );
    });

    const matches = props.matchesBySport[selectedSport];
    const params = useParams();
    const aggId = parseIntFromString(params.aggId);
    let allBetsUrl = null;
    const conf = getConfiguration();
    if (params.date != null) {
        allBetsUrl = `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${urls.prematch.allMatches}/${params.date}/${params.sportId}/${aggId}`;
    } else {
        allBetsUrl = `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${urls.prematch.today}`;
    }

    let scommesse = matches?.[0]?.gruppiScommessa?.[0]?.scommesse;
    if (scommesse) {
        scommesse = filtraParametriche(scommesse);
        scommesse = filterBetsByNumberOfOdds(scommesse);
    }

    const now = new Date();
    const nowTime = now.toTimeString().slice(0, 5); // "HH:mm"

    function compareByCurrentTime(aTime, bTime) {
        const isAPast = aTime < nowTime;
        const isBPast = bTime < nowTime;

        if (isAPast && !isBPast) return 1;
        if (!isAPast && isBPast) return -1;
        return aTime.localeCompare(bTime);
    }

    return (
        <>
            {/* <div className="container-slider-icone mb-2 overflow-unset has-icons-container-no-wrap">
                <div className="icons-slider-container">
                    <div className="slider-icone-sport horiz-sc icons-container icons-container-no-wrap" ref={iconsContainer}>
                        {sportButtons}
                    </div>
                </div>
            </div>
            <div className="bg-nero bianco titolo-blocco-sport pointer">
                <span className="d-centro-v maiuscolo">
                    <div className={`img-fluid icona-sport margine-dx-mezzo ico-sport ${iconSportCssClass(selectedSport, null)}`}></div>
                    {props.descBySport[selectedSport]}
                </span>
            </div> */}
            {scommesse == null ?
                <>
                    {/* <div className="tab-pane fade show active" id="scheda-top-match-2" role="tabpanel">
                        <MessageInfo message={`${getLabel('prematch_page.widget.last_minute')} ${getLabel('general.chiuso')}`} />
                    </div> */}
                </>
                :
                <>
                    <div className="l_2">
                        {sportButtons}
                    </div>
                    {systemCode === 'SUREBET' ?
                        (
                            Object.entries(
                                matches.reduce((acc, match) => {
                                    const key = match.tournamentRef;
                                    if (!acc[key]) {
                                        acc[key] = {
                                            tournamentDesc: match.tournamentDesc,
                                            matches: []
                                        };
                                    }
                                    acc[key].matches.push(match);
                                    return acc;
                                }, {})
                            )
                                // Ordino i gruppi in base al time del primo match, rispetto all’orario attuale
                                .sort(([, a], [, b]) => {
                                    const timeA = a.matches[0]?.time ?? '99:99';
                                    const timeB = b.matches[0]?.time ?? '99:99';
                                    return compareByCurrentTime(timeA, timeB);
                                })
                                .map(([tournamentRef, group]) => (
                                    <div key={tournamentRef}>
                                        <div className='xs_tournamentHeader flex items-center truncate'>
                                            <span className='font-bold text-sm text-cs10 truncate'>{group.tournamentDesc}</span>
                                        </div>
                                        {group.matches
                                            .slice()
                                            .sort((a, b) => compareByCurrentTime(a.time, b.time))
                                            .map(match => (
                                                <TournamentEvent key={match.id} data={match} />
                                            ))}
                                    </div>
                                ))
                        )
                        :
                        matches.map(function (match) {
                            return (
                                <TournamentEvent key={match.id} data={match} />
                            );
                        })
                    }

                    {conf.iwh &&
                        <div className='flex items-center py-3 mb-[1px] bg-white '><XRouterLink to={allBetsUrl} className=" w-full text-[#2290C7] text-[12px] font-[600] flex justify-center items-center">{getLabel('general.all_matches')}</XRouterLink>
                        </div>
                    }
                </>
            }
        </>
    );
}

export default function Upcoming() {
    const conf = getConfiguration();
    const [isLoading, isError, data] = useFetch(conf.api.getWidgetCentrali, null, (data) =>
        parseWidgetData(data, false)
    );

    if (isLoading || isError) {
        return <Loader error={isError} />;
    }

    return (
        conf.iwh ? (data.lastMinute && <UpcomingContent {...data.lastMinute} />) : <UpcomingContent {...data.lastMinute} />
    );
}
